import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { Link, useHistory } from 'react-router-dom';
import SettingsCard from '../../UI/SettingsCard/SettingsCard';
import { useLockedFeatures } from '../../../providers/LockedFeatures.provider';
import { useLockedFeatureDialogue } from '../../../providers/LockedFeatureDialogue.provider';
import { usePermissions } from '../../../providers/Permissions.provider';
import { useTranslation } from 'react-i18next';
// ID-12905 spike — throwaway
import { SpikeNavDemo } from 'shared/spike';
import { SPIKE_SHARED_PORTAL_PATH } from '@/constants';

const { Box, Title, SubTitle } = vp;
type FC = FunctionComponent;

const Settings: FC = () => {
  const history = useHistory();
  const lockedFeatures = useLockedFeatures();
  const { updateIsLocked } = useLockedFeatureDialogue();
  const { permissions } = usePermissions();
  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });

  return (
    <div>
      <Box mb="md" jc="sb">
        <Title title={t('pageTitle')} />

        {/* ID-12905 spike — dev-only, throwaway: host page linking back into the shared spike route */}
        {import.meta.env.DEV && (
          <>
            <Link to={SPIKE_SHARED_PORTAL_PATH}>Spike: shared portal</Link>

            <Link to={SpikeNavDemo.routes.subPage.getPath({ basePath: SPIKE_SHARED_PORTAL_PATH })}>
              Spike: shared sub-page
            </Link>
          </>
        )}
      </Box>

      <Box flx="col">
        <SubTitle subTitle={t('pageSubtitle')} />

        <Box mt="sm">
          <div>
            <SettingsCard
              Image="webhooks"
              Title={t('webhooksCardTitle')}
              onClickDetails={() => {
                history.push('/settings/webhooks');
              }}
            />

            <SettingsCard
              Image="brandSettings"
              Title={t('brandingCardTitle')}
              isLocked={
                !lockedFeatures.BrandingELinxEnabled &&
                !lockedFeatures.BrandingEmailEnabled &&
                !lockedFeatures.BrandingOnboardingEnabled &&
                !lockedFeatures.BrandingPortalEnabled
              }
              onClickDetails={() => {
                !lockedFeatures.BrandingELinxEnabled &&
                !lockedFeatures.BrandingEmailEnabled &&
                !lockedFeatures.BrandingOnboardingEnabled &&
                !lockedFeatures.BrandingPortalEnabled
                  ? updateIsLocked(true, 'Branding')
                  : history.push('/settings/brand-settings');
              }}
            />

            <SettingsCard
              Image="paylink"
              Title={t('elinxCardTitle')}
              isLocked={!lockedFeatures.PayLinkEnabled}
              onClickDetails={() => {
                !lockedFeatures.PayLinkEnabled ? updateIsLocked(true, 'eLinx') : history.push('/settings/elinx');
              }}
            />

            <SettingsCard
              Image="ipAddress"
              Title={t('authorizedIpsCardTitle')}
              onClickDetails={() => {
                history.push('/settings/authorized-ips');
              }}
            />

            {permissions.ManageEmailDomains && (
              <SettingsCard
                Image="domainSetup"
                Title={t('domainSetupCardTitle')}
                isLocked={!lockedFeatures.EmailDomainEnabled}
                onClickDetails={() => {
                  !lockedFeatures.EmailDomainEnabled
                    ? updateIsLocked(true, 'Domain Setup')
                    : history.push('/settings/domain-setup');
                }}
              />
            )}
          </div>
        </Box>
      </Box>
    </div>
  );
};

export default Settings;
